import React from "react"
import { Formik } from "formik"
import { Link } from "react-router-dom"
import Yup from "yup"
import FormWrapper from "components/Form/FormFields/FormWrapper"
import FormTitle from "components/Form/FormFields/FormTitle"
import ErrorMessage from "components/Form/FormFields/ErrorMessage"
import TextInput from "components/Form/FormFields/TextInput"
import SubmitButton from "components/Form/FormFields/SubmitButton"
import glamorous from "glamorous"
import style from "utils/style"

export class UserLoginForm extends React.Component {
  componentWillReceiveProps(newProps) {
    if (this.props.isSubmitting && newProps.hasErrors) {
      this.props.setSubmitting(false)
    }
  }

  render() {
    const {
      values,
      touched,
      errors,
      isSubmitting,
      handleChange,
      handleBlur,
      handleSubmit,
      hasErrors,
    } = this.props

    return (
      <Container>
        <FormTitle>Sign In</FormTitle>

        {hasErrors && (
          <ErrorMessage>
            Login failed. Please check your credentials and try again.
          </ErrorMessage>
        )}

        <FormWrapper onSubmit={handleSubmit}>
          <TextInput
            id="email"
            label="Email"
            placeholder="Enter your email"
            type="text"
            value={values.email}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.email && errors.email}
            inline
          />

          <TextInput
            id="password"
            label="Password"
            placeholder="Enter your password"
            type="password"
            value={values.password}
            onChange={handleChange}
            onBlur={handleBlur}
            error={touched.password && errors.password}
            inline
          />

          <SubmitButton type="submit" isSubmitting={isSubmitting}>
            Sign In
          </SubmitButton>
        </FormWrapper>

        <StyledLink to="/forgot_password">Forgot your password?</StyledLink>
      </Container>
    )
  }
}

export const validationSchema = Yup.object().shape({
  password: Yup.string().required("password is required"),
  email: Yup.string()
    .email("must be a valid email address")
    .required("email is required"),
})

const UserLoginFormik = Formik({
  mapPropsToValues: () => ({ email: "", password: "" }),
  validationSchema,
  handleSubmit: (values, bag) => {
    bag.props.handleSubmit(values.email, values.password)
  },
  displayName: "UserLoginForm",
})

export default UserLoginFormik(UserLoginForm)

const Container = glamorous.div({
  display: "flex",
  flexDirection: "column",
  justifyContent: "center",
  border: `1px solid ${style.colors.mintGreen}`,
  background: "white",
  margin: "3rem auto",
  padding: "3rem",
  width: "40rem",
  [style.size.mobile]: {
    width: "100%",
  },
})

const StyledLink = glamorous(Link)({
  textDecoration: "none",
  textAlign: "center",
  color: style.colors.primaryBlue,
  marginTop: "2rem",
  "&:hover": {
    textDecoration: "underline",
    color: style.colors.darkerPrimaryBlue,
  },
})



// WEBPACK FOOTER //
// ./src/components/Form/UserLoginForm/index.js